export const SCROLLABLE_CAROUSEL = 'ADP_RV_SC_PDP';
export const PRICE_IN_CTA = 'ADP_RV_PRICE_CTA';
export const EXP_AB_SHARE_EARN = 'ADP_RV_SHARE_EARN';
export const CUSTOM_BANNER = 'ADP_RV_CUSTOM_BANNER';
export const VIEW_SIMILAR_EXP_HLP = 'ADP_RV_VIEW_SIMILAR_HLP';
export const VIEW_SIMILAR_EXP = 'ADP_RV_VIEW_SIMILAR';
export const CLICKABLE_RATINGS = 'ADP_RV_CLICKABLE_RATING';
export const EFFECTIVE_PRICE = 'EFFECTIVE_PRICE';
export const HYBRID_PLP = 'ADP_RV_HYBRID_PLP';
export const RECENTLY_VIEWED_SEARCH_WIDGET = 'ADP_RV_RECENTLY_VIEWED';
export const PRODUCT_COMPARISON = 'PRODUCT_COMPARISON';
export const PLP_PRODUCT_CARD = 'PLP_PRODUCT_CARD';
export const AB_PAGINATION = 'AB_PAGINATION';
export const HEADER_NAV_COLOUR = 'HEADER_NAV_COLOUR';
export const PDP_WIDGET_SEQUENCE = 'PDP_WIDGET_SEQUENCE';
export const PLP_PRODUCT_CARD_V3 = 'ADP_RV_PRODUCT_V3';
export const PDP_CATEGORY_RECO_WIDGET = 'PDP_CATEGORY_RECO_WIDGET';
export const PLP_INLINE_FILTER = 'PLP_INLINE_FILTER';
export const NEW_SEARCH_BAR = 'ADP_RV_SEARCH_BAR_NEW';
export const PLP_INLINE_WIDGETS = 'PLP_INLINE_WIDGETS';
export const SLP_INLINE_WIDGETS = 'SLP_INLINE_WIDGETS';
export const PRIVE_MULTI_COUPONS = 'PRIVE_MULTI_COUPONS';
export const PDP_RECO_MODAL = 'PDP_RECO_MODAL';
export const PLP_PINKBOX_CTA = 'PLP_PINKBOX_CTA';
export const SIZE_INFO_PDP = 'SIZE_INFO_PDP';
export const ORGANIC_GUIDES = 'ORGANIC_GUIDES';
export const QUERY_PARAM_EXP = 'QUERY_PARAM_EXP';
export const BRAND_BASED_CAV = 'BRAND_BASED_CAV';
export const AB_CALLOUT_NUDGE = 'AB_CALLOUT_NUDGE';
export const USER_SEGMENT_EXP = 'USER_SEGMENT';
export const AB_HLP_CTA = 'AB_HLP_CTA';
export const AB_BREADCRUMB_POSITION = 'AB_BREADCRUMB_POSITION';
export const AB_SIZE_MINI_PRODUCT = 'AB_SIZE_MINI_PRODUCT';
export const AB_TOP_NAV_CONFIG = 'AB_TOP_NAV_CONFIG';
export const AB_HP_SEARCH_ANIMATION = 'AB_HP_SEARCH_ANIMATION';
export const AB_BEAUTY_PORTFOLIO = 'AB_BEAUTY_PORTFOLIO';
export const AB_HLP_OFFERS = 'AB_HLP_OFFERS';
export const COMBO_PRODUCTS_REVIEWS = 'COMBO_PRODUCTS_REVIEWS';
export const AB_PDP_HAMBURGER = 'AB_PDP_HAMBURGER';
export const AB_PAGE_NOT_FOUND = 'AB_PAGE_NOT_FOUND';
export const AB_PDP_IMAGE = 'AB_PDP_IMAGE';
export const AB_HLP_CARD_REVAMP = 'AB_HLP_CARD_REVAMP';
export const PDP_RELEVANT_CATEGORY = 'PDP_RELEVANT_CATEGORY';
export const AB_WEB_AUTOREAD_OTP = 'AB_WEB_AUTOREAD_OTP';
export const CART_NUDGE = 'CART_NUDGE';
export const AB_AUTOFILL = 'AB_AUTOFILL';
export const AB_GOOGLE_ONE_TAP = 'AB_GOOGLE_ONE_TAP';
export const AB_REMOVE_LOGIN_BOTTOMSHEET = 'AB_REMOVE_LOGIN_BOTTOMSHEET';
export const AB_TRUECALLER = 'AB_TRUECALLER';
export const AB_IOC_CART_NUDGE = 'AB_IOC_CART_NUDGE';
export const AB_AGG_FOOTER_SSR = 'AB_AGG_FOOTER_SSR';
export const AB_FULL_HEIGHT_IMG_CONTAINER = 'AB_FULL_HEIGHT_IMG_CONTAINER';
export const AB_DISMISSABLE_TOOLTIP = 'AB_DISMISSABLE_TOOLTIP';
export const AB_HORIZONTAL_WIDGET_TYPE = 'AB_HORIZONTAL_WIDGET_TYPE';
export const APPSFLYER_DOWNLOAD_CTA = 'APPSFLYER_DOWNLOAD_CTA';
export const COUPONS_DELTA_COMMUNICATION = 'COUPONS_DELTA_COMMUNICATION';
export const OFFERS_DELTA_COMMUNICATION = 'OFFERS_DELTA_COMMUNICATION';
export const AB_ENABLE_HLP_NEW_API = 'AB_ENABLE_HLP_NEW_API';
export const AB_BEST_SELLER_PDP = 'AB_BEST_SELLER_PDP';
export const FULL_SCREEN_RECO_WIDGET = 'FULL_SCREEN_RECO_WIDGET';
export const AB_PDP_HOME = 'AB_PDP_HOME';
export const AB_TAGS_ON_LISTING = 'AB_TAGS_ON_LISTING';
export const AB_RATING_SUMMARY_ON_IMAGE = 'AB_RATING_SUMMARY_ON_IMAGE';
export const AB_TAGS_RATING_ON_LISTING = 'AB_TAGS_RATING_ON_LISTING';
export const AB_NEW_BUYERS_SKU = 'AB_NEW_BUYERS_SKU';
export const AB_ORDERS_REVAMP = 'ORDERS_REVAMP';
export const AB_EDD_TIMER_STRIP = 'AB_EDD_TIMER_STRIP';
export const SNP_BEST_PRICE = 'SNP_BEST_PRICE';
export const AB_PLP_PR_V5 = 'AB_PLP_PR_V5';
export const AB_EMAIL_VERIF_REVAMP = 'AB_EMAIL_VERIF_REVAMP';
export const AB_OFFER_DELTA_COMMUNICATION = 'AB_OFFER_DELTA_COMMUNICATION';
export const AB_PDP_SIMILAR_PRODUCT_SHEET = 'AB_PDP_SIMILAR_PRODUCT_SHEET';
export const AB_NEW_TAGS_ON_PDP = 'AB_NEW_TAGS_ON_PDP';
export const AB_REORDER_PDP = 'AB_REORDER_PDP';
export const AB_CART_GRATIFICATION_POPUP = 'CART_GRATIFICATION_POPUP';
export const AB_CART_DFA = 'AB_CART_DFA';
export const AB_CART_FREE_SHIPPING = 'AB_CART_FREE_SHIPPING';
export const AB_EMPTY_CART = 'EMPTY_CART';
export const AB_EXPRESS_CHECKOUT = 'AB_EXPRESS_CHECKOUT';
export const AB_CART_NEW_SIGN_UP = 'NEW_SIGN_UP';
export const PLP_IMG_RESIZE = 'PLP_IMG_RESIZE';
export const PLP_VARIANT_COLOR = 'PLP_VARIANT_COLOR';
export const AB_CART_BEST_COUPON = 'BEST_COUPON';
export const ERROR_BOUNDARY = 'ERROR_BOUNDARY';
export const PRIVE_CTA_DISABLE = 'PRIVE_CTA_DISABLE';
export const AB_NYKAA_NOW_FILTER = 'AB_NYKAA_NOW_FILTER';
export const AB_SEARCHCOUNT_MWEB = 'AB_SEARCHCOUNT_MWEB';
export const AB_NEW_SHOPPING_BAG = 'AB_NEW_SHOPPING_BAG';
export const AB_FOOTER_CTA_TEXT = 'AB_FOOTER_CTA_TEXT';
export const AB_SEARCH_INP_ON_CART = 'SEARCH_INP_ON_CART';
export const AB_PARTIAL_CHECKOUT = 'AB_PARTIAL_CHECKOUT';
export const AB_PRIVE_BAND = 'AB_PRIVE_BAND';
export const AB_CART_OFFERS = 'AB_CART_OFFERS';
export const AB_HLP_EDD = 'AB_HLP_EDD';
export const PLP_IMG_CAROUSEL = 'PLP_IMG_CAROUSEL';
export const AB_VISUAL_FILTERS_PLP = 'AB_VISUAL_FILTERS_PLP';
export const DW_APP_BANNER = 'DW_APP_BANNER';
export const AB_GETAPPNUDGE_MWEB = 'AB_GETAPPNUDGE_MWEB';
export const CART_SAVINGS_SHELF = 'CART_SAVINGS_SHELF';
export const AB_NYKAA_NOW_PDP = 'AB_NYKAA_NOW_PDP';
export const QUICK_VIEW_CART = 'QUICK_VIEW_CART';
export const AB_MWEB_FILTERS_PLP = 'AB_MWEB_FILTERS_PLP';
export const SPECIAL_DEALS = 'SPECIAL_DEALS';
export const AB_CONVENIENCE_FEE = 'AB_CONVENIENCE_FEE';
export const AB_NYKAA_NOW_CART = 'AB_NYKAA_NOW_CART';
export const AB_CAB_VERTICAL = 'AB_CAB_VERTICAL';
export const MINI_COUPONS_OFFERS = 'MINI_COUPONS_OFFERS';
export const AB_CHECKOUT_REVAMP = 'AB_CHECKOUT_REVAMP';
export const AB_SALE_PRICE_TAG = 'AB_SALE_PRICE_TAG';
export const AB_NYKAA_NOW_RAAP = 'AB_NYKAA_NOW_RAAP';
export const CART_STEP_COUNTER = 'CART_STEP_COUNTER';
export const SECONDARY_TAGS_V2 = 'SECONDARY_TAGS_V2';
export const AB_DS_AUTH_FLOW = 'AB_DS_AUTH_FLOW';
export const AB_SHOW_ASPECTS = 'AB_SHOW_ASPECTS';
export const PLP_VARIANT_SELECTOR = 'PLP_VARIANT_SELECTOR';
export const COLLAPSED_PRICE_DETAILS = 'COLLAPSED_PRICE_DETAILS';
export const AB_BOTTOM_NAV = 'AB_BOTTOM_NAV';
export const PLP_DESIGN_PARITY = 'PLP_DESIGN_PARITY';
export const CATEGORY_NUDGE = 'CATEGORY_NUDGE';
export const AB_BP_DN_PERS = 'AB_BP_DN_PERS';
export const PDP_BUY_NOW = 'PDP_BUY_NOW';
export const AB_FREE_GIFT = 'AB_FREE_GIFT';
export const MAP_PICKER = 'MAP_PICKER';
export const CART_GROUPING = 'CART_GROUPING';
export const AB_EDD_DESIGN_V2 = 'AB_EDD_DESIGN_V2';
export const PRODUCT_IMG_V2 = 'PRODUCT_IMG_V2';
export const STORE_SUGGESTION = 'STORE_SUGGESTION';
export const CART_MINI_PDP = 'CART_MINI_PDP';
export const AB_STICKY_PRICE_V2 = 'AB_STICKY_PRICE_V2';
